import CustomButton, {
  BtnRadius,
  BtnSizes,
  BtnTypes,
} from "@/app/components/lib/CustomButton";
import SpinnerForBtn from "@/app/components/lib/loaders/SpinnerForBtn";

interface Props {
  isLoading?: boolean;
  children: any;
  onClick?: () => void;
  disabled?: boolean;
  error?: boolean;
}

const AuthButton: React.FC<Props> = ({
  isLoading = false,
  onClick,
  disabled = false,
  error = false,
  children,
}) => {
  return (
    <div style={{ marginTop: 40 }}>
      <CustomButton
        isSubmit={!onClick}
        type={BtnTypes.primary}
        size={BtnSizes.large}
        radius={BtnRadius.small}
        fullWidth
        disabled={disabled || error}
        onClick={onClick}
      >
        {children}
        {isLoading && <SpinnerForBtn />}
      </CustomButton>
    </div>
  );
};

export default AuthButton;
